// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowDropdownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12">
            <path
                fill="currentColor"
                d="M0.056333279,4.78125 C0.173271877,5.0625 0.453924512,5.25 0.757964867,5.25 L8.24203513,5.25 C8.54607549,5.25 8.82672812,5.0625 8.94366672,4.78125 C9.06060532,4.5 8.99044216,4.1953125 8.77995268,3.9609375 L5.03791755,0.2109375 C4.7338772,-0.0703125 4.2661228,-0.0703125 3.96208245,0.2109375 L0.220047316,3.9609375 C0.00955783984,4.1953125 -0.0606053189,4.5 0.0797209986,4.78125 L0.056333279,4.78125 Z M0.056333279,7.21875 C-0.0606053189,7.5 0.00955783984,7.8046875 0.220047316,8.0390625 L3.96208245,11.7890625 C4.2661228,12.0703125 4.7338772,12.0703125 5.03791755,11.7890625 L8.77995268,8.0390625 C8.99044216,7.8046875 9.06060532,7.5 8.94366672,7.21875 C8.82672812,6.9375 8.54607549,6.75 8.24203513,6.75 L0.757964867,6.75 C0.453924512,6.75 0.173271877,6.9375 0.056333279,7.21875 Z"
            />
        </svg>
    );
};

export default React.memo(IconArrowDropdownSmall);
